import { render } from "./SupplierSectionClassification.vue?vue&type=template&id=1f730998&scoped=true"
import script from "./SupplierSectionClassification.vue?vue&type=script&lang=js"
export * from "./SupplierSectionClassification.vue?vue&type=script&lang=js"

import "./SupplierSectionClassification.vue?vue&type=style&index=0&id=1f730998&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f730998"]])

export default __exports__